module.exports = __webpack_public_path__ + "static/media/cat-post-3.09b7ee20.jpg";